import { STATUS } from "@constants/status.hrm";
import { URLS } from "@constants/urls";

import api from "@helpers/api";

const { EMPLOYEES } = URLS;
const { SUCCESS, FAILED } = STATUS;

const apiEndPoint = `${process.env.REACT_APP_TERMINATION_SERVICE_URL}${process.env.REACT_APP_TERMINATION_SERVICE_PORT}/${process.env.REACT_APP_TERMINATION_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${EMPLOYEES}/termination`;

export const getTermination = (() => {
  return async (terminationId: string | number | null) => {
    return api
      .get(`${apiEndPoint}/${terminationId}`)
      .then((response) => response.data);
  };
})();

export const initiateTermination = (() => {
  return async (
    isCreatePage: boolean,
    data: any,
    afterEffect: (param: any) => void,
    terminationId?: string,
    flowUpdate?: boolean,
  ): Promise<{ data: any }> => {
    return api[isCreatePage ? "post" : "put"](
      isCreatePage
        ? apiEndPoint
        : flowUpdate
        ? `${apiEndPoint}/${terminationId}/flow-update`
        : `${apiEndPoint}/${terminationId}`,
      {
        ...data,
      },
    )
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return {
          data: response.data,
        };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });
        return {
          data: response,
        };
      });
  };
})();
